module.exports = __webpack_public_path__ + "static/media/task_asign_alert.13ecb3da.svg";